(function () {
  const section = document.querySelector('.shopify-section--main-collection');
  if (!section) return;

  const productList = section.querySelector('.product-list');
  const sortSelect = section.querySelector('[data-collection-sort]');
  const loadMoreBtn = section.querySelector('[data-load-more]');
  const tabsTrack = section.querySelector('[data-collection-tabs-track]');
  const resultsStatus = section.querySelector('[data-collection-results-status]');

  function scrollActiveTabIntoView() {
    if (!tabsTrack) return;

    const activeTab = tabsTrack.querySelector('.chip.active');
    if (!activeTab) return;

    const tabLeft = activeTab.offsetLeft;
    const tabRight = tabLeft + activeTab.offsetWidth;
    const viewLeft = tabsTrack.scrollLeft;
    const viewRight = viewLeft + tabsTrack.clientWidth;

    if (tabLeft < viewLeft || tabRight > viewRight) {
      tabsTrack.scrollTo({
        left: Math.max(tabLeft - 16, 0),
        behavior: 'auto'
      });
    }
  }

  function bindSwatchPreview(scope) {
    const root = scope || document;

    root.querySelectorAll('[data-swatch-preview]').forEach(function (swatch) {
      const card = swatch.closest('.product-card');
      if (!card) return;

      const mainImage = card.querySelector('.product-card__image--primary');
      if (!mainImage) return;

      if (!mainImage.dataset.originalSrc) {
        mainImage.dataset.originalSrc = mainImage.currentSrc || mainImage.src;
      }

      swatch.addEventListener('mouseenter', function () {
        const preview = swatch.getAttribute('data-swatch-preview');
        if (preview) mainImage.src = preview;
      });

      swatch.addEventListener('focus', function () {
        const preview = swatch.getAttribute('data-swatch-preview');
        if (preview) mainImage.src = preview;
      });

      card.addEventListener('mouseleave', function () {
        if (mainImage.dataset.originalSrc) {
          mainImage.src = mainImage.dataset.originalSrc;
        }
      });
    });
  }

  scrollActiveTabIntoView();
  bindSwatchPreview(section);

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async function () {
      const nextUrl = this.getAttribute('data-next-url');
      if (!nextUrl || this.classList.contains('is-loading')) return;

      this.classList.add('is-loading');
      this.disabled = true;

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newSection = doc.querySelector('.shopify-section--main-collection');
        const newList = newSection && newSection.querySelector('.product-list');
        const newButton = newSection && newSection.querySelector('[data-load-more]');

        if (newList && productList) {
          const newCards = newList.querySelectorAll('.product-card');
          const loadedCount = newCards.length;

          newCards.forEach(function (card) {
            productList.appendChild(card);
          });

          bindSwatchPreview(productList);

          if (resultsStatus && loadedCount > 0) {
            const displayedCount = productList.querySelectorAll('.product-card').length;
            const resultsMessage = resultsStatus.dataset.resultsMessage || 'Product results updated. [count] products displayed.';
            resultsStatus.textContent = resultsMessage.replace('[count]', String(displayedCount));
            resultsStatus.dataset.resultsCount = String(displayedCount);
          }
        }

        if (newButton) {
          const newNextUrl = newButton.getAttribute('data-next-url') || '';
          loadMoreBtn.setAttribute('data-next-url', newNextUrl);
        } else {
          loadMoreBtn.removeAttribute('data-next-url');
          loadMoreBtn.closest('.load-more-wrap')?.remove();
        }
      } catch (error) {
        console.error('Load more failed', error);
      } finally {
        this.classList.remove('is-loading');
        this.disabled = false;

        if (!this.getAttribute('data-next-url')) {
          this.closest('.load-more-wrap')?.remove();
        }
      }
    });
  }
})();
